import React from "react";
// import { Form } from "react-bootstrap";

const ErrorLabel = ({
  value,
  ...rest
}) => {
  return (
    <>
    <p style={{color : "red", fontWeight:"bold"}}>{value}</p>
   
    </>
  );
};

export default ErrorLabel;
